import {
  APP_GOOGLE_PLAY_STORE_URL,
  APP_REDIRECT_DOWNLOAD_URL,
} from "@utils/constants";
import { FC } from "react";
import { IconButton } from "@shared/components/icon-button";
import IconCloseModal from "@svg/access/CloseModal";
import OutlinedDownLoadIcon from "@svg/new-design/outline-download";
import GooglePlayLogo from "assets/patterns/GooglePlay";
import Link from "next/link";
import { ICON_SIZE } from "@shared/components/icon-button/types";

interface Props {
  onClose: () => void;
}

const DownloadAppBanner: FC<Props> = ({ onClose }) => {
  return (
    <div className="fixed lg:hidden overflow-hidden right-0 left-0 bottom-0 bg-fds-primary shadow-bottom-tab-navigation rounded-t-16 z-[100]">
      <div className="rounded-2 h-1 w-16 mx-auto bg-fds-tertiary mt-2" />
      <div className="flex justify-between px-4     pb-4     pt-1 border-b border-fds-divider items-center">
        <p className="headline-sm text-fds-primary">دانلود اپلیکیشن فرادرس</p>
        <IconButton
          aria-label="بستن"
          icon={<IconCloseModal />}
          size={ICON_SIZE.MEDIUM}
          onClick={onClose}
        />
      </div>
      <div className="w-full p-4     flex items-center gap-2">
        <Link
          href={APP_GOOGLE_PLAY_STORE_URL}
          target="_blank"
          className="bg-fds-inverse-secondary w-1/2 flex justify-between items-center px-3  py-0.5 rounded-6"
        >
          <div>
            <p className="title-xsm text-fds-disable text-right">دانلود از</p>
            <p className="text-fds-on-inverse title-md-demibold text-right">
              Google Play
            </p>
          </div>
          <GooglePlayLogo />
        </Link>
        <Link
          href={APP_REDIRECT_DOWNLOAD_URL}
          target="_blank"
          className="bg-fds-inverse-secondary w-1/2 flex justify-between items-center px-3  py-0.5 rounded-6"
        >
          <div>
            <p className="title-xsm text-fds-disable text-right">
              دانلود مستقیم
            </p>
            <p className="text-fds-on-inverse title-md-demibold text-right">
              نسخه Android
            </p>
          </div>
          <OutlinedDownLoadIcon className="text-fds-on-inverse" />
        </Link>
      </div>
    </div>
  );
};

export default DownloadAppBanner;
